// Single source of truth for Account page nav
// Shared between Angular and React Router components

const initialState = [
  {
    name: 'Concierge Reservations',
    path: 'account/concierge-reservations',
    translationKey: 'concierge_reservations',
    selectedMatcher: 'concierge-reservations',
    isSelected: false,
    isConcierge: true,
  },
  {
    name: 'Reservations &amp; Notify',
    path: 'account/reservations-and-notify',
    translationKey: 'reservations_and_notify',
    selectedMatcher: 'reservations-and-notify',
    isSelected: false,
  },
  {
    name: 'Profile',
    path: 'account/profile',
    translationKey: 'profile',
    selectedMatcher: 'profile',
    isSelected: false,
  },
  {
    name: 'Lists',
    path: 'account/lists',
    translationKey: 'lists.title',
    selectedMatcher: 'lists',
    isSelected: false,
  },
  {
    name: 'Payment Methods',
    path: 'account/payment-methods',
    translationKey: 'payment_methods_title',
    selectedMatcher: 'payment-methods',
    isSelected: false,
  },
  {
    name: 'Communication',
    path: 'account/communication',
    translationKey: 'communication_title',
    selectedMatcher: 'communication',
    isSelected: false,
  },
  {
    name: 'Global Dining Access',
    translationKey: 'rga',
    isGlobalDiningAccess: true,
  },
  {
    name: 'Help & Feedback',
    path: 'account/help-and-feedback',
    translationKey: 'help_and_feedback_heading',
    selectedMatcher: 'help-and-feedback',
    isSelected: false,
  },
];

// GDA item requires external onClick handler to initialize.
const getInitialNavState = (onClick) => {
  const navState = [...initialState];
  const gdaItem = navState.find((item) => item.isGlobalDiningAccess === true);
  gdaItem.onClick = onClick;

  return navState;
};

export default getInitialNavState;
